var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3535 2.6216C15.7092 2.97272 15.7092 3.54686 15.3535 3.89798L5.82252 13.3065C5.43307 13.691 4.80693 13.691 4.41748 13.3065L0.64672 9.58419C0.290907 9.23295 0.290907 8.65861 0.64672 8.30737C0.995792 7.96279 1.55691 7.96245 1.90638 8.30663L5.12 11.4715L14.0938 2.6213C14.4431 2.27683 15.0044 2.27696 15.3535 2.6216Z",
    fill: "#052987"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.b725177f8a46e96f522eac3e650fc998.svg";
export { ForwardRef as ReactComponent };